var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3327 20.9577L20.4993 29.1243C20.8327 29.4577 20.9924 29.8466 20.9785 30.291C20.9646 30.7355 20.791 31.1243 20.4577 31.4577C20.1243 31.7632 19.7355 31.923 19.291 31.9368C18.8466 31.9507 18.4577 31.791 18.1243 31.4577L7.12435 20.4577C6.95768 20.291 6.83963 20.1105 6.77018 19.916C6.70074 19.7216 6.66602 19.5132 6.66602 19.291C6.66602 19.0688 6.70074 18.8605 6.77018 18.666C6.83963 18.4716 6.95768 18.291 7.12435 18.1243L18.1243 7.12435C18.4299 6.81879 18.8118 6.66602 19.2702 6.66602C19.7285 6.66602 20.1243 6.81879 20.4577 7.12435C20.791 7.45768 20.9577 7.85352 20.9577 8.31185C20.9577 8.77018 20.791 9.16602 20.4577 9.49935L12.3327 17.6243H30.9577C31.4299 17.6243 31.8257 17.7841 32.1452 18.1035C32.4646 18.423 32.6243 18.8188 32.6243 19.291C32.6243 19.7632 32.4646 20.1591 32.1452 20.4785C31.8257 20.798 31.4299 20.9577 30.9577 20.9577H12.3327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftWhiteIcon);
export default __webpack_public_path__ + "static/media/arrow-left-white-icon.2fc769731b6572ce017ac13039b245ff.svg";
export { ForwardRef as ReactComponent };